import React,{ useState } from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import Table from '../../../../../../components/Table';
import { customClassification } from "../../../../../../common/functions/utils";
import ConfirmMessage from '../../../../../../components/Confirmation';
import styles from '../../guest.module.css';


function ListGuests(props) {
  const guestList = props.guests.filter(
    (guest) =>
      guest.name.toLocaleLowerCase().includes(props.search.toLocaleLowerCase()) ||
      guest.emailId.toLocaleLowerCase().includes(props.search.toLocaleLowerCase())
  );

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [confirmDel,setConfirmDel]=useState(false);
  const [delData,setDelData]=useState(null);

  const cols = [
    { lable: 'ID', key: 'id' },
    { lable: 'Name', key: 'name' },
    { lable: 'Email', key: 'emailId' },
    { lable: 'Phone', key: 'phoneNo' },
    { lable: 'Company', key: 'company' },
    { lable: 'Actions', key: '' },
  ];
 
  return (
    <div>
      <Container fluid>
        <Row >
          <Col md={"auto"} className={`pt-3`}>
              <h5 className={styles.contactTableTitle}>Contacts Table</h5>
              <p className={styles.contactTableSubtitle}>
                This is a list of all your customers - whether they stayed at your property, made a reservation, or both.
              </p>
              <Table
                  rows={customClassification(guestList, order, orderBy)}
                  cols={cols}
                  onEdit={props.onEdit}
                  onDelete={(row)=>{
                      setConfirmDel(true);
                      setDelData(row);
                  }}
                  order={order}
                  setOrder={setOrder}
                  orderBy={orderBy}
                  setOrderBy={setOrderBy}
              />
          </Col>
        </Row>
      </Container>
      <ConfirmMessage
          show={confirmDel}
          onHide={() => {
            setConfirmDel(false);
            setDelData(null);
          }}
          confirmHeader='Delete contact'
          confirmBody={(
            <div className={styles.confirmMessageContainer}>
              <p>
                Deleting this contact will permanently remove all linked information.
              </p>
              <p>
                Guests with existing reservations cannot be deleted. To proceed, you must first delete all bookings associated with this guest.
              </p>
              <p>
                This action cannot be undone. Are you sure you want to continue?
              </p>
            </div>
          )}
          onConfirmAct={()=> {
              props.onDelete(delData);
              setConfirmDel(false);
          }}
      />
    </div>
  )}
export default ListGuests;
